function clearGlobalVariables() {

    /*
        Suresh: do we to add this?

    global.$regitems            = null;
    global.$regsubitems         = null;
    global.$regdropdownoptions  = null;
    */

    global.$selectedregoptions = null;
    global.$registereditems = null;
    global.$totalregitems = null;
    global.$attendeeregitems = null;
    global.$guestregitems = null;
    global.$regItemsForSignupCount = null;

    global.$deferredpromo = null;
    global.$deferredpromoamount = null;
    global.$regamount = null;
    global.$finalamount = null;

    global.$hideregisterbutton = null;
    global.$selectedPaymentOption = null;
    global.$regdiscountinfo = null;
    global.$regattendeestatus = null;
    global.$reggueststatus = null;
    global.$regemail = null;
    global.$reguestemail = null;
    global.$regattendeeinfo = null;
    global.$regguestinfo = null;
    global.$loggedinguest = null;
    global.$guestexist = null;
    global.$terms1status = null;
    global.$terms2status = null;
    global.$terms3status = null;
    global.$paymentid = null;
    global.$upgradepricediff = null;
    // global.$loggedinuserregitems = null;
    global.$regitemtoreducecount = null;
    global.$isattendeeregistered = null;
    global.$isguestregistered = null;
    global.$transactionfee = null;
    global.$openpaymentpopup = false; // this will cntrols payment popup
}

function printGlobalRegItems()
{
    console.log('------- Reg Items ----------')
    
    //console.log(`regitems:`)
    //console.log(global.$regitems)
    //console.log(`regsubitems:`)
    //console.log(`regsubitems)
    //console.log(`regdropdownoptions = ${global.$regdropdownoptions}`)

    console.log(`global.$selectedregoptions:`)
    console.log(global.$selectedregoptions)

    console.log(`global.$registereditems:`)
    console.log(global.$registereditems)

    console.log(`regItemsForSignupCount`)
    console.log(getRegItemsForSignupCount(global.$selectedregoptions))

    console.log(`global.$attendeeregitems:`)
    console.log(global.$attendeeregitems)

    console.log(`global.$guestregitems`)
    console.log(global.$guestregitems)

    console.log(`global.$totalregitems`)
    console.log(global.$totalregitems)

    console.log('----------------------------')
}

function printGlobalAmounts()
{
    console.log('------- Amounts ----------')

    console.log(`regamount = ${global.$regamount}`)   
    console.log(`finalamount = ${global.$finalamount}`)   

    //console.log(`regamount = ${global.$regamount}`)   
    //console.log(`regamount = ${global.$regamount}`)   
    console.log('---------------------------')
}

function isUserLoggedin() {
    var result = false;
    if (global.$loginstatus.includes("true")) {
        result = true;
    }
    return result;
}

function isAttendeeTabEnabled() {
    var result = false;
    if (global.$registrationform.setup != null && global.$registrationform.setup.attendee.enable == true) {
        result = true;
    }
    return result;
}
function isExhibitorTabEnabled() {
    var result = false;
    if (global.$registrationform.setup.exhibitor != null && global.$registrationform.setup.exhibitor.enable == true) {
        result = true;
    }
    return result;
}

function isSponsorTabEnabled() {
    var result = false;
    if (global.$registrationform.setup.sponsor != null && global.$registrationform.setup.sponsor.enable == true) {
        result = true;
    }
    return result;
}
function isUserType(type) {
    var result = false;
    if (global.$userstype == `${type}`) {
        result = true;
    }
    return result;
}
function isGuestAdded() {
    var result = false;
    if (global.$attendeeguests != null && global.$attendeeguests != "" && global.$attendeeguests != " ") {
        result = true;
    }
    return result;
}
function activeTabIs(type, tab) {
    var result = false;
    if (type == tab) {
        result = true;
    }
    return result;
}
function isAttendeeTab(type) {
    var result = false;
    if (type == "attendee") {
        result = true;
    }
    return result;
}
function isExhibitorTab(type) {
    var result = false;
    if (type == "exhibitor") {
        result = true;
    }
    return result;
}
function isSponsorTab(type) {
    var result = false;
    if (type == "sponsor") {
        result = true;
    }
    return result;
}

function getValueFromMeCard(tag, name) {

    //console.log(`getValueFromTag ${tag}, ${name}`)

    var val = ''

    name = name + ':'

    var begin = tag.indexOf(name)
    if (begin != -1) {

        begin = tag.indexOf(':', begin)
        var end = tag.indexOf(';', begin)

        if (begin != -1 && end != -1) {
            val = tag.substr(begin + 1, end - begin - 1)
        }
    }

    return val
}

function isUserAlreadyRegisteredForThisItem(regitem) {
    var result = false;
    if (global.$loggedinuserregitems != null && global.$loggedinuserregitems.includes(regitem)) {
        var regitems = global.$loggedinuserregitems
        //console.log(regitems);
        //console.log("Reg option from login");
        regitems = regitems.split(",");
        regitems.map(item => {
            regitem = regitem.trim();
            if (item.startsWith(regitem)) {
                result = true;
            }
        })
    }
    return result;
}

function covertGroupIDToSectionID(groupid) {
    if (groupid == 'one')
        return 'section1'
    else if (groupid == 'two')
        return 'section2'
    else if (groupid == 'three')
        return 'section3'
    else if (groupid == 'four')
        return 'section4'
    else if (groupid == 'five')
        return 'section5'
}

function getRegItemsForGroup(groupname) {
    var result = [];
    // loop through all the reg items and filter by group
    global.$regitems.map(regitem => {
        //console.log(regitem);
        if (regitem.groupname == groupname) {
            result.push(regitem);
        }
    })
    return result;
}

function getRegItemStyle() {
    var regitemstyle = "";
    if (global.$registrationform != null && global.$registrationform.styles.regoptions != null) {
        regitemstyle = global.$registrationform.styles.regoptions.regitemname
    }
    return regitemstyle;
}

function isRadioInput(regitem) {
    if (regitem.inputtype.includes("radio")) {
        return true;
    }
    else {
        return false;
    }
}
function isCheckboxInput(regitem) {
    if (regitem.inputtype.includes("checkbox")) {
        return true;
    }
    else {
        return false;
    }
}
function isNumberInput(regitem) {
    if (regitem.inputtype.includes("number")) {
        return true;
    }
    else {
        return false;
    }
}
function isDropdownInput(regitem) {
    if (regitem.inputtype.includes("dropdown")) {
        return true;
    }
    else {
        return false;
    }
}

function getLoggedInUserRegItems() {
    var result = "";
    if (isUserLoggedin() && global.$loggedinuser != null) {
        result = global.$loggedinuser.regtype;
    }
    global.$registereditems = result;
    return result;
}

function getLoggedInUserPendingAmount() {
    var result = 0;
    if (isUserLoggedin() && global.$loggedinuser != null) {
        result = Number(global.$loggedinuser.pendingamount);
    }
    return result;
}

/*
    Returns regitems selected by user from global.$regitems. 
*/
function getUserSelectedRegItems() {
    var result = [];
    //console.log(global.$regitems)
    global.$regitems.map(regitem => {
        if (regitem.isChecked == true) {
            result.push(regitem);
        }
    })
    //console.log(result);
    global.$selectedregoptions = result;
    return result;
}

function isRegDiscountExist() {
    if (global.$regdiscountinfo != null && global.$regdiscountinfo != "") {
        return true;
    }
    else {
        return false;
    }
}

/*
    Returns values based on input type

    dropdown:      
        Subitem:ID:itemid;N:item.name~~
    
    number: quantity > 0
        Regquantity:Q:quantity;N;name~~

    number: quantity == 0
        item.name~~
        
*/

function getRegItemsForSignupCount(selectedregoptions) {
    var selectedregitems = "";
    selectedregoptions.map((item) => {
        var name = "";
        if (item.inputtype == "dropdown" && item.itemid != "") {
            name = "Subitem:ID:" + item.itemid + ";N:" + item.dropdownvalue;
        }
        else if (item.inputtype == "number" && item.quantity != "0") {
            name = "Regquantity:Q:" + item.quantity + ";N:" + item.name;
        }
        else {
            name = item.name
        }

        if (selectedregitems != "") {

            selectedregitems = selectedregitems + "~~" + name;
        }
        else {
            selectedregitems = name;
        }
    })

    return selectedregitems.toString();
}

function isGuestEnabledFromConfig() {
    if (global.$registrationform.guests != null && global.$registrationform.guests.required == true) {
        return true;
    }
    else {
        return false;
    }
}

/*
    NOTE: In TravCon attendee, AfterParty and Bruch Tickets are part of Guest section
*/
function isUserSelectedGuest(selectedregoptions) {
    var result = false;
    selectedregoptions.map(item => {
        //console.log(item)
        if (item.groupname.includes("guest") || item.groupname.includes("Guest")) {
            result = true;
        }
    })
    //console.log(result);
    return result;
}

// check guest details 
function isGuestUserDetails() {
    var result = false;
    if (global.$regattendeeinfo != null && global.$regattendeeinfo.guestname != null && global.$regattendeeinfo.guestname != "" && global.$regattendeeinfo.guestname != " ") {
        result = true;
    }
    return result;
}

// check guest email and attendee email
function isCommonEmail() {
    var results = false;
    var result = isGuestUserDetails();
    if (result === true) {
        if (global.$regattendeeinfo.email === global.$regattendeeinfo.guests) {
            results = true;
        }
    }
    return results;
}

// check guest registration items
function isGuestUserRegItem(selectedregitems) {
    var guestInfoEntered = false;
    guestInfoEntered = isUserSelectedGuest(selectedregitems);
    return guestInfoEntered;
}

// check guest registeration ( update registration )
function isGuestUpdate() {
    var result = false;
    let guestregitems = global.$regattendeeinfo.regtype.split(",")

    global.$regitems.map((item) => {
        if (item.groupname.includes("guest") || item.groupname.includes("Guest")) {
            guestregitems.map(reg => {
                if(reg.includes(item.name)){
                    result = true;
                }
            })
            
        }
    })
    return result;
    
}

function sortRegItems(data) {
    return data.sort(function (a, b) {  // sorting the regoptions based onn data1 field
        var nameA = a.data1, nameB = b.data1

        if (nameA < nameB) //sort string ascending
            return -1
        if (nameA > nameB)
            return 1

        return 0 //default return value (no sorting) 
    })
}




export default { sortRegItems, isUserSelectedGuest, isGuestEnabledFromConfig, getRegItemsForSignupCount, isRegDiscountExist, getUserSelectedRegItems, getLoggedInUserRegItems, getLoggedInUserPendingAmount, isRadioInput, isCheckboxInput, isNumberInput, isDropdownInput, getRegItemStyle, getRegItemsForGroup, isUserAlreadyRegisteredForThisItem, getValueFromMeCard, isAttendeeTab, isExhibitorTab, isSponsorTab, clearGlobalVariables, isUserLoggedin, isExhibitorTabEnabled, isSponsorTabEnabled, isAttendeeTabEnabled, isUserType, isGuestAdded, activeTabIs, covertGroupIDToSectionID, printGlobalRegItems, printGlobalAmounts, isGuestUserDetails, isGuestUserRegItem, isGuestUpdate, isCommonEmail };